import ComponentCircleLoader from 'components/Loaders/ComponentCircleLoader';
import moment from 'moment';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import BackButtonComponent from '../../../components/BackButtonComponent/BackButtonComponent';
import CreateProjectDropdown from '../../../components/DropdownStyle/CreateProjectDropdown';
import ButtonTextLoader from '../../../components/Loaders/ButtonTextLoader';
import { filterOption } from '../../../components/ReactSelectDropdown/ReactSelectDropdown';
import { PrimaryButton } from '../../../styledComponents/buttons';
import {
  CommonText,
  Container,
  ContentHeader,
  InputWithLabelSection,
  PageTitle,
} from '../../../styledComponents/common';
import { checkHtml, checkUrl } from '../../../utils/helper';
import CheckList from '../CreateTask/checkList';
import CheckLists from '../CreateTask/checkLists';
import { InputSection } from '../CreateTask/createTaskStyles';
import CreateEditTaskForm from '../create-editTaskForm';

const EditTask = ({
  isLoading,
  orgMembersList,
  officesShortList,
  addTaskLocationLoading,
  getTaskDetails,
  taskDetails,
  editTask,
  callback,
  locationsList,
  createdTaskLocationInfo,
  memberShortListIsLoading,
  getOrganizationMembersList,
  getTaskType,
  createTask,
  getTaskLocation,
  addTaskLocation,
  getOfficesShortList,
  taskTypeIsLoading,
  taskTypeList,
  history,
  location,
  addSubTask,
  deleteSubTask,
  editSubTask,
  getPublicZoneList,
  publicZoneList,
  getDefaultSubTasks,
  defaultSubTasks,
  newDefaultSubTask,
  isAddDefaultSubTaskLoading,
  addDefaultSubTask,
  clearNewDefaultSubTask,
  masterTasksList,
  getMasterTasks,
}) => {
  const { t, i18n } = useTranslation();

  const [taskName, setTaskName] = useState('');
  const [selectedTask, setSelectedTask] = useState(null);
  const [masterTaskOptions, setMasterTaskOptions] = useState([]);
  const [selectedOffice, setSelectedOffice] = useState('');
  const [officeOptions, setOfficeOptions] = useState([]);
  const [selectedPublicZone, setSelectedPublicZone] = useState('');
  const [publicZoneOptions, setPublicZoneOptions] = useState([]);
  const [defaultCheckListOptions, setDefaultCheckListOptions] = useState([]);
  const [selectedAssignees, setSelectedAssignees] = useState([]);
  const [requiresApproval, setRequiresApproval] = useState(false);
  const [taskDescription, setTaskDescription] = useState('');
  const [selectedLocation, setSelectedLocation] = useState('');
  const [taskLocationOptions, setTaskLocationOptions] = useState([]);
  const [startDate, setStartDate] = useState(
    moment(new Date()).add(5, 'minutes'),
  );
  const [endDate, setEndDate] = useState(moment(new Date()).add(65, 'minutes'));
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [selectedTaskType, setSelectedTaskType] = useState('');
  const [popupOpen, setPopupOpen] = useState(false);

  const [saveErrors, setSaveErrors] = useState({});
  const [statusOptions, setStatusOptions] = useState([]);
  const [taskId, setTaskId] = useState(null);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [checklistData, setChecklistData] = useState([]);

  const [taskDetailsLoaded, setTaskDetailsLoaded] = useState(false);

  const [isSameLocationWarningModalOpen, setIsSameLocationWarningModalOpen] =
    useState(false);
  const popupToggleSameLocationWarningModal = () => {
    setIsSameLocationWarningModalOpen(!isSameLocationWarningModalOpen);
  };

  const updateSubTaskRequest = data => {
    const payload = {
      task_id: taskDetails?.id,
      sub_task_id: data.id,
      data: { name: data.name },
    };
    editSubTask(payload);
  };

  useEffect(() => {
    if (location.search) {
      const queryParsed = queryString.parse(location.search);
      setTaskId(queryParsed.id);
      getTaskDetails({ task_id: queryParsed.id });
    }
    getTaskType();
    getPublicZoneList();
    getTaskLocation();
  }, []);

  useEffect(() => {
    if (
      selectedOffice &&
      selectedPublicZone &&
      locationsList &&
      locationsList.length > 0
    ) {
      const filteredLocations = locationsList.filter(location => {
        const matchesOffice =
          selectedOffice.value === null ||
          location.office_id === selectedOffice.value;
        const matchesPublicZone =
          location.public_zone === selectedPublicZone.value;

        return matchesOffice && matchesPublicZone;
      });

      const newLocationOptions = filteredLocations.map(location => ({
        label: location.name,
        value: location.id,
        ...location,
      }));

      setTaskLocationOptions(newLocationOptions);

      if (
        selectedLocation &&
        !newLocationOptions.some(
          option => option.value === selectedLocation.value,
        )
      ) {
        setSelectedLocation('');
      }
    } else {
      setTaskLocationOptions([]);
      setSelectedLocation('');
    }
  }, [selectedOffice, selectedPublicZone, locationsList]);

  useEffect(() => {
    if (publicZoneList && publicZoneList.length > 0) {
      let newArr = [];
      publicZoneList.forEach(zone => {
        newArr.push({
          label: zone.name,
          value: zone.id,
        });
      });
      setPublicZoneOptions(newArr);
    }
  }, [publicZoneList]);

  useEffect(() => {
    if (selectedPublicZone.value) {
      getOfficesShortList({
        public_zone_id: selectedPublicZone.value,
      });
    }
  }, [selectedPublicZone]);
  useEffect(() => {
    if (defaultSubTasks) {
      let newArr = [];
      defaultSubTasks.forEach(subTask => {
        newArr.push({
          name: subTask.name,
          id: subTask.id,
          default_sub_task_id: subTask.id,
        });
      });
      setDefaultCheckListOptions(newArr);
    }
  }, [defaultSubTasks]);

  useEffect(() => {
    if (taskDetails) {
      taskDetails.name &&
        setSelectedTask({ label: taskDetails.name, value: taskDetails.name });
      taskDetails.name && setTaskName(taskDetails.name);
      taskDetails.office &&
        taskDetails.office.id &&
        setSelectedOffice({
          label: taskDetails.office.name,
          value: taskDetails.office.id,
        });
      taskDetails.public_zone &&
        taskDetails.public_zone.id &&
        setSelectedPublicZone({
          label: taskDetails.public_zone.name,
          value: taskDetails.public_zone.id,
        });
      // if (taskDetails.assignees && taskDetails.assignees.length > 0) {
      //   let newArr = [];
      //   taskDetails.assignees.forEach((assignee, i) => {
      //     newArr.push({
      //       ...assignee,
      //       name:
      //         `${assignee.first_name} ${assignee.last_name}`.trim() ||
      //         assignee.first_name,
      //     });
      //   });

      //   setSelectedAssignees(newArr);
      // }
      if (taskDetails.location && taskDetails.location.id) {
        setSelectedLocation({
          label: taskDetails.location.name,
          value: taskDetails.location.id,
          ...taskDetails.location,
        });
      }
      if (taskDetails.description) {
        setTaskDescription(taskDetails.description);
      }
      if (taskDetails.required_start_date) {
        const startDate = moment(taskDetails.required_start_date).format(
          'YYYY-MM-DD',
        );
        const startTime = moment(taskDetails.required_start_date).format(
          'HH:mm',
        );
        setStartDate(moment(startDate));
        setStartTime(startTime);
      }
      if (taskDetails.required_end_date) {
        const endDate = moment(taskDetails.required_end_date).format(
          'YYYY-MM-DD',
        );
        const endTime = moment(taskDetails.required_end_date).format('HH:mm');
        setEndDate(moment(endDate));
        setEndTime(endTime);
      }
      if (taskDetails.task_type && taskDetails.task_type.id) {
        statusOptions.map((option, i) => {
          if (option.value === taskDetails.task_type.id) {
            setSelectedTaskType({
              label: option.label,
              value: option.value,
            });
          }
        });
      }
      if (taskDetails.sub_tasks?.length > 0) {
        setChecklistData(taskDetails.sub_tasks);
      } else setChecklistData([]);
    }
  }, [taskDetails]);

  useEffect(() => {
    if (taskDetails && startTime && endTime && !taskDetailsLoaded) {
      if (
        startTime === moment(taskDetails.required_start_date).format('HH:mm') &&
        endTime === moment(taskDetails.required_end_date).format('HH:mm')
      ) {
        setTaskDetailsLoaded(true);
      }
    }
  }, [startTime, endTime, taskDetails]);

  useEffect(() => {
    const checkSelectedOffice = officesShortList?.filter(
      office => office.id === selectedOffice?.value,
    );
    if (officesShortList && officesShortList.length > 0) {
      let newArr = [];
      officesShortList.forEach((office, i) => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      if (!(checkSelectedOffice?.length > 0)) {
        onOfficeChange({
          label: officesShortList[0].name,
          value: officesShortList[0].id,
        });
      }
      setOfficeOptions(newArr);
    } else if (officesShortList?.length === 0) {
      setOfficeOptions([]);
      setSelectedOffice(null);
      setTaskLocationOptions([]);
      setSelectedLocation(null);
    }
  }, [officesShortList]);

  useEffect(() => {
    const options = masterTasksList?.map(task => ({
      ...task,
      label: task.name,
      value: task.id,
    }));
    if (options.some(option => option.label === selectedTask?.label)) {
      const task = options.find(option => option.label === selectedTask.label);
      setSelectedTask(task);
    }
    setMasterTaskOptions(options);
  }, [masterTasksList]);

  const setDefaultLocation = office => {
    if (
      selectedLocation?.office !== office?.value &&
      selectedLocation?.id !== createdTaskLocationInfo?.id
    ) {
      const officeLocations = taskLocationOptions?.filter(
        location => location?.office?.id === office?.value,
      );

      const defaultLocation = officeLocations?.filter(
        location => location.name === office?.label,
      );

      if (defaultLocation?.length >= 1) {
        setSelectedLocation(defaultLocation[0]);
      } else if (officeLocations?.length >= 1) {
        setSelectedLocation(locationsList[0]);
      } else {
        setSelectedLocation(officeLocations[0]);
      }
    }
  };

  useEffect(() => {
    if (
      selectedOffice &&
      selectedOffice.value &&
      officesShortList &&
      officesShortList.length > 1
    ) {
      if (selectedPublicZone) {
        getDefaultSubTasks({
          public_zone_id: selectedPublicZone.value,
          office_id: selectedOffice.value,
        });
      }
      getOrganizationMembersList({ office_id: selectedOffice.value });
      getMasterTasks({
        related_office: selectedOffice.value,
        public_zone: selectedPublicZone.value,
      });
    }
  }, [selectedOffice, officesShortList]);

  useEffect(() => {
    if (locationsList && locationsList.length > 0) {
      let newArr = [];
      locationsList.forEach(location => {
        newArr.push({
          label: location.name,
          value: location.id,
          ...location,
        });
      });
      setTaskLocationOptions(newArr);
    }
  }, [locationsList]);

  useEffect(() => {
    if (taskTypeList && taskTypeList.length > 0) {
      let newArr = [];
      if (i18n.language && i18n.language === 'en') {
        taskTypeList.forEach(type => {
          newArr.push({
            label: type.name,
            value: type.id,
          });
        });
      } else {
        taskTypeList.forEach(type => {
          newArr.push({
            label: type.arabic_name,
            value: type.id,
          });
        });
      }
      setStatusOptions(newArr);
    }
  }, [taskTypeList]);

  useEffect(() => {
    if (callback && isSubmitted) {
      history.push({
        pathname: '/user/tasks',
        state: { from: 'create' },
      });
    }
  }, [callback]);

  const onTaskNameChange = selectedOption => {
    let errors = { ...saveErrors };
    delete errors['selectedTask'];
    setSaveErrors(errors);
    if (
      selectedOption &&
      !masterTaskOptions?.some(option => option.label === selectedOption?.label)
    ) {
      setMasterTaskOptions([...masterTaskOptions, selectedOption]);
    }
    setSelectedTask(selectedOption);
  };

  const onOfficeChange = e => {
    setSelectedOffice(e);
    setDefaultLocation(e);
  };

  const onPublicZoneChange = e => {
    setSelectedPublicZone(e);
  };

  const approvalToggle = () => {
    setRequiresApproval(!requiresApproval);
  };

  // const handleAssignOrRemoveMember = (user, action) => {
  //   if (user && user.id) {
  //     let newArr = [...selectedAssignees];
  //     if (action === 'remove') {
  //       newArr = newArr.filter(member => member.id !== user.id);
  //     } else {
  //       newArr.push(user);
  //     }
  //     setSelectedAssignees(newArr);
  //   }
  // };

  const handleAssignMember = user => {
    // handleAssignOrRemoveMember(user, 'assign');
  };

  const handleRemoveMember = user => {
    // handleAssignOrRemoveMember(user, 'remove');
  };

  const onTaskDescriptionChange = e => {
    let errors = { ...saveErrors };
    delete errors['taskDescription'];
    setSaveErrors(errors);
    setTaskDescription(e.target.value);
  };

  const onLocationChange = e => {
    setSelectedLocation(e);
  };

  const popupToggle = () => {
    setPopupOpen(!popupOpen);
  };

  const handleAddCheckList = data => {
    const payload = {
      task_id: taskDetails?.id,
      data,
    };
    addSubTask(payload);
  };

  const handleDeleteCheckList = id => {
    const payload = {
      task_id: taskDetails?.id,
      sub_task_id: id,
    };
    deleteSubTask(payload);
  };

  const handleSave = () => {
    if (checkError() && taskId) {
      if (selectedOffice && selectedOffice.value) {
        const start_date = moment(
          startDate.format('YYYY-MM-DD') + ' ' + startTime,
        );
        const end_date = moment(endDate.format('YYYY-MM-DD') + ' ' + endTime);
        // let assigneeIds = [];
        // if (selectedAssignees && selectedAssignees.length > 0) {
        //   selectedAssignees.forEach(element => {
        //     assigneeIds.push(element.id);
        //   });
        // }
        let payload = {
          task_id: taskId,
          name: selectedTask?.label,
          office_id: selectedOffice.value,
          public_zone_id: selectedPublicZone.value,
          // assignees: assigneeIds,
          description: taskDescription,
          location_id: selectedLocation.value,
          required_start_date: moment(start_date).format(
            'YYYY-MM-DDTHH:mm:ssZ',
          ),
          required_end_date: moment(end_date).format('YYYY-MM-DDTHH:mm:ssZ'),
          sub_tasks: checklistData ? checklistData : [],
        };
        if (
          selectedTask?.value &&
          selectedTask?.value !== selectedTask?.label
        ) {
          payload.master_task_id = selectedTask?.value;
        }
        const officeLocation = officesShortList.find(
          office => office.id === selectedOffice.value,
        ).location;
        if (
          officeLocation.latitude === selectedLocation.latitude &&
          officeLocation.longitude === selectedLocation.longitude &&
          isSameLocationWarningModalOpen === false
        ) {
          setIsSameLocationWarningModalOpen(true);
          return;
        }
        editTask(payload);
        setIsSubmitted(true);
      }
    }
  };

  const checkError = () => {
    let saveErrors = {};
    let formIsValid = true;
    if (!selectedTask) {
      formIsValid = false;
      saveErrors['selectedTask'] = t('task_name_is_required');
    } else {
      if (!selectedTask.label.trim()) {
        formIsValid = false;
        saveErrors['selectedTask'] = 'Task name is required';
      } else if (checkUrl(selectedTask.label)) {
        formIsValid = false;
        saveErrors['selectedTask'] = 'Task name can not contain url.';
      } else if (checkHtml(selectedTask.label)) {
        formIsValid = false;
        saveErrors['selectedTask'] = 'Invalid Task name';
      } else if (selectedTask.label.length > 255) {
        formIsValid = false;
        saveErrors['selectedTask'] = 'Maximum length 255 characters';
      }
    }
    // if (selectedAssignees.length === 0) {
    //   formIsValid = false;
    //   saveErrors['selectedAssignees'] = 'Assignee is required';
    // }
    if (taskDescription?.length === 0) {
      formIsValid = false;
      saveErrors['taskDescription'] = 'Description is required';
    } else if (checkUrl(taskDescription)) {
      formIsValid = false;
      saveErrors['taskDescription'] = 'Task description can not contain url.';
    } else if (checkHtml(taskDescription)) {
      formIsValid = false;
      saveErrors['taskDescription'] = 'Invalid Task description';
    } else if (taskDescription.length > 512) {
      formIsValid = false;
      saveErrors['taskDescription'] = 'Maximum length 512 characters';
    }
    if (!startDate) {
      formIsValid = false;
    }
    if (!startTime || !endTime) {
      formIsValid = false;
    }
    if (
      selectedTask &&
      selectedTask?.max_task_duration >= 0 &&
      moment(endDate.format('YYYY-MM-DD') + ' ' + endTime).diff(
        moment(startDate.format('YYYY-MM-DD') + ' ' + startTime),
      ) >
        selectedTask?.max_task_duration * 60 * 60 * 1000
    ) {
      formIsValid = false;
      saveErrors['timeDifferenceEndTime'] = `${t('max_task_duration_is')} ${
        selectedTask?.max_task_duration
      } ${t('hours')}`;
    } else if (
      moment(endDate.format('YYYY-MM-DD') + ' ' + endTime).diff(
        moment(startDate.format('YYYY-MM-DD') + ' ' + startTime),
      ) < 1
    ) {
      formIsValid = false;
      saveErrors['timeDifferenceEndTime'] = t(
        'end_time_must_be_after_start_time',
      );
    } else if (
      moment(endDate.format('YYYY-MM-DD') + ' ' + endTime).diff(
        moment(startDate.format('YYYY-MM-DD') + ' ' + startTime),
      ) < 1800000
    ) {
      formIsValid = false;
      saveErrors['timeDifferenceEndTime'] =
        'Minimum 30 minutes time difference required';
    }
    if (
      moment(startDate.format('YYYY-MM-DD') + ' ' + startTime).diff(moment()) <
      1
    ) {
      formIsValid = false;
      saveErrors['timeDifferenceStartTime'] = t('past_time_cant_be_set');
    }
    setSaveErrors(saveErrors);
    return formIsValid;
  };

  return (
    <div className="content">
      <PageTitle>{t('edit_task')}</PageTitle>
      <ContentHeader>
        <BackButtonComponent
          onClick={() => history.push('/user/tasks')}
          subTitle={t('back_to_all_tasks')}
        />
      </ContentHeader>
      {isLoading && !taskDetails ? (
        <ComponentCircleLoader />
      ) : (
        <Container padding="30px" gap="20px">
          <CommonText name title fontSize="16px">
            {t('add_task_details')}
          </CommonText>
          <InputSection>
            {taskDetailsLoaded && (
              <CreateEditTaskForm
                {...{
                  selectedOffice,
                  officeOptions,
                  officesShortList,
                  filterOption,
                  selectedTask,
                  saveErrors,
                  setSaveErrors,
                  memberShortListIsLoading,
                  // selectedAssignees,
                  orgMembersList,
                  handleAssignMember,
                  handleRemoveMember,
                  startTime,
                  setStartTime,
                  startDate,
                  setStartDate,
                  endTime,
                  setEndTime,
                  endDate,
                  setEndDate,
                  selectedLocation,
                  taskLocationOptions,
                  taskDescription,
                  onOfficeChange,
                  CreateProjectDropdown,
                  onTaskNameChange,
                  popupToggle,
                  onTaskDescriptionChange,
                  onLocationChange,
                  publicZoneOptions,
                  publicZoneList,
                  selectedPublicZone,
                  onPublicZoneChange,
                  isSameLocationWarningModalOpen,
                  popupToggleSameLocationWarningModal,
                  handleSave,
                  isLoading,
                  popupOpen,
                  addTaskLocation,
                  addTaskLocationLoading,
                  createdTaskLocationInfo,
                  getTaskLocation,
                  getOfficesShortList,
                  masterTaskOptions,
                  checklistData,
                  setChecklistData,
                }}
                creating={false}
              />
            )}
            <InputWithLabelSection style={{ gridColumn: `1 / span 2` }}>
              <CheckLists
                updateSubTaskRequest={updateSubTaskRequest}
                checklistData={checklistData}
                deleteCheckList={handleDeleteCheckList}
              />
              <CheckList
                {...{
                  newDefaultSubTask,
                  isAddDefaultSubTaskLoading,
                  addDefaultSubTask,
                  selectedPublicZone,
                  clearNewDefaultSubTask,
                  checklistData,
                }}
                handleAddCheckList={handleAddCheckList}
                defaultCheckListOptions={defaultCheckListOptions}
              />
            </InputWithLabelSection>
            <PrimaryButton
              margin="80px 0 150px 0"
              disabled={
                !taskName ||
                !selectedOffice ||
                // selectedAssignees.length === 0 ||
                !selectedLocation ||
                !startTime ||
                !endTime
              }
              onClick={() => handleSave()}
            >
              {isLoading ? (
                <ButtonTextLoader
                  loadingText={t('edit_task')}
                  fontSize="13px"
                />
              ) : (
                t('edit_task')
              )}
            </PrimaryButton>
            <div />
          </InputSection>
        </Container>
      )}
    </div>
  );
};

export default EditTask;
